export default "__VITE_ASSET__B2Gg0Wcu__"